import { render, staticRenderFns } from "./tabIndex.vue?vue&type=template&id=5ce5c7e9&scoped=true&"
import script from "./tabIndex.vue?vue&type=script&lang=ts&"
export * from "./tabIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce5c7e9",
  null
  
)

export default component.exports